import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { guardArray } from "@msuite/utils/array";
import { ContactMemberCard, UserCard } from "@/components/cards";
import { useProtocol } from "@/hooks/use-protocol";
import type { ProtocolPanelBaseProps } from "../shared";

export function ProtocolInvolvements({ protocolId }: ProtocolPanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { protocol } = useProtocol(protocolId);

	/** Computed */
	const involvements = guardArray(protocol?._involvements);

	/** Render */
	return (
		<ContentCard
			icon={icon("Users")}
			title={t("protocols.involvements")}
		>
			{!involvements.length ? (
				<p>{t("protocols.no_recipients")}</p>
			) : (
				<div className="v-stack gap-2">
					{involvements.map((involvement) =>
						involvement.userId ? (
							<UserCard
								key={involvement.id}
								userId={involvement.userId}
								variant="plain"
							/>
						) : involvement.contactMemberId ? (
							<ContactMemberCard
								key={involvement.id}
								contactMemberId={involvement.contactMemberId}
								variant="plain"
							/>
						) : null,
					)}
				</div>
			)}
		</ContentCard>
	);
}
